import { HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";
import { signalRUrl, fileSignalR } from "../productionStatus";

let defaultUrl = signalRUrl;

let userTracker = null;
let customerSupport = null;
let logger = null;
let upload = null;
let plc = null;

function userTrackerHub(token) {
  userTracker = new HubConnectionBuilder()
    .withUrl(defaultUrl + "usertrackerhub", {
      accessTokenFactory: () => token,
      transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .build();
  return userTracker;
}
function customerSupportHub(token) {
  customerSupport = new HubConnectionBuilder()
    .withUrl(defaultUrl + "customersupporthub", {
      accessTokenFactory: () => token,
      transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .build();
  return customerSupport;
}
function loggerHub(token) {
  logger = new HubConnectionBuilder()
    .withUrl(defaultUrl + "d7kloggerhub", {
      accessTokenFactory: () => token,
      transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .build();
  return logger;
}
function uploadHub(token) {
  upload = new HubConnectionBuilder()
    .withUrl(fileSignalR + "uploadHub", {
      accessTokenFactory: () => token,
      transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .build();
  return upload;
}

function plcHub(token) {
  plc = new HubConnectionBuilder()
    // https://g0tz51q2-7029.euw.devtunnels.ms/plchub
    // https://plcreaderapi.d7ksuper.com/plchub

    .withUrl("https://plcreaderapi.d7ksuper.com/plchub", {
      accessTokenFactory: () => token,
      transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .build();
  return logger;
}
async function startHub(hub) {
  if (hub) {
    try {
      await hub.start();

      return { connectionId: hub.connection.connectionId };
    } catch (error) {
      //  console.error("Error starting hub connection:", error);
      throw error;
    }
  } else {
    //  console.error("Hub connection is not initialized.");
  }
}

async function stopHub(hub) {
  if (hub) {
    try {
      await hub.stop();
    } catch (error) {
      //  console.error("Error starting hub connection:", error);
      throw error;
    }
  } else {
    // console.error("Hub connection is not initialized.");
  }
}

export {
  userTrackerHub,
  customerSupportHub,
  startHub,
  userTracker,
  customerSupport,
  loggerHub,
  uploadHub,
  upload,
  logger,
  plc,
  plcHub,
  stopHub,
};
